import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Params, Router} from '@angular/router';
import * as Showdown from 'showdown';

import {Language} from 'classes/language';
import {Badge} from 'shared/models/badges/badge';
import {BadgeType} from 'shared/models/badges/badge-type';
import {TranslatedText} from 'shared/models/translated-text';
import {BadgeTypeFactoryService} from 'shared/badges/services/badge-type-factory.service';
import {BadgesDetailsService} from './services/badges-details.service';
import {BadgeComponent} from 'shared/badges/components/badge-component/badge.component';

@Component({
  selector: 'badges-details',
  templateUrl: './badges-details.component.html',
  styleUrls: ['./badges-details.component.css'],
})
export class BadgesDetailsComponent implements OnInit {

  public languages: Array<Language> = Language.defaultLanguages;
  public language: string = this.languages[0].code;
  public badge: Badge = {
    title: TranslatedText.createEmptyInstance(),
    description: TranslatedText.createEmptyInstance(),
    type: <BadgeType> {name: '', prettyName: '', validate: () => { return 'empty'; } },
    active: true,
    shape: "1",
    color: "#FFDD00",
    orderno: undefined,
  };
  public errorText: string = null;

  public showMarkdownOutput: boolean = false;
  private markdownOutput: {
    de: string,
    en: string,
  };
  private converter: Showdown.Converter = new Showdown.Converter();


  constructor(private badgesDetailsService: BadgesDetailsService,
              private badgeTypeFactoryService: BadgeTypeFactoryService,
              private activatedRoute: ActivatedRoute,
              private router: Router) {
    this.converter.setFlavor('github')
  }

  public ngOnInit(): void {
    this.markdownOutput = {de: '', en: ''};
    this.activatedRoute.params.map((urlParameters: Params) => {
      return urlParameters['badgeId'];
    })
      .subscribe((badgeId: string) => {
        if (badgeId) {
          this.getBadge(badgeId);
        }
      });
    this.activatedRoute.params.map((urlParameters: Params) => {
      return urlParameters['orderno'];
    })
      .subscribe((orderno: number) => {
          this.badge.orderno = orderno;
      });
  }

  public changeType(type: string): void {
    this.badge.type = this.badgeTypeFactoryService.createBadgeType(type);
  }

  public onSubmit(): void {
    if (this.badge._id) {
      this.updateBadge();
    } else {
      this.saveBadge();
    }
  }

  private getBadge(id: string): void {
    this.badgesDetailsService.getBadge(id)
      .subscribe((badge: Badge) => {
        this.badge = badge;
        this.updateMarkdown();
      });
  }

  private saveBadge(): void {
    this.errorText = this.badge.type.validate();
    if (this.errorText != null) {
      return;
    }
    this.badgesDetailsService.saveBadge(this.badge)
      .subscribe((badge: Badge) => {
        this.router.navigateByUrl('/badges');
      });
  }

  private updateBadge(): void {
    this.errorText = this.badge.type.validate();
    if (this.errorText != null) {
      return;
    }
    this.badgesDetailsService.updateBadge(this.badge)
      .subscribe((badge: Badge) => {
        this.router.navigateByUrl('/badges');
      });
  }

  public setLanguage(language: Language): void {
    this.language = language.code;
  }

  public get caption(): string {
    return this.badge._id ? 'Badge bearbeiten' : 'Badge erstellen';
  }

  public get submitButtonText(): string {
    return this.badge._id ? 'Speichern' : 'Erstellen';
  }

  private setMarkdownOutput(value: boolean): void {
    this.showMarkdownOutput = value;
  }

  private updateMarkdown(): void {
    this.markdownOutput[this.language] = this.converter.makeHtml(this.badge.description[this.language]);
  }

}



// WEBPACK FOOTER //
// /usr/src/app/src/app/modules/badges/badges-details/badges-details.component.ts